import _classCallCheck from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Signal } from "./Signal";
import { optionsFromArguments } from "../core/util/Defaults";
import { TransportTimeClass } from "../core/type/TransportTime";
import { ToneConstantSource } from "./ToneConstantSource";
/**
 * Adds the ability to synchronize the signal to the [[Transport]]
 */
export var SyncedSignal = /*#__PURE__*/function (_Signal) {
  _inherits(SyncedSignal, _Signal);
  var _super = _createSuper(SyncedSignal);
  function SyncedSignal() {
    var _this;
    _classCallCheck(this, SyncedSignal);
    _this = _super.call(this, optionsFromArguments(Signal.getDefaults(), arguments, ["value", "units"]));
    _this.name = "SyncedSignal";
    /**
     * Don't override when something is connected to the input
     */
    _this.override = false;
    var options = optionsFromArguments(Signal.getDefaults(), arguments, ["value", "units"]);
    _this._lastVal = options.value;
    _this._synced = _this.context.transport.scheduleRepeat(_this._onTick.bind(_assertThisInitialized(_this)), "1i");
    _this._syncedCallback = _this._anchorValue.bind(_assertThisInitialized(_this));
    _this.context.transport.on("start", _this._syncedCallback);
    _this.context.transport.on("pause", _this._syncedCallback);
    _this.context.transport.on("stop", _this._syncedCallback);
    // disconnect the constant source from the output and replace it with another one
    _this._constantSource.disconnect();
    _this._constantSource.stop(0);
    // create a new one
    _this._constantSource = _this.output = new ToneConstantSource({
      context: _this.context,
      offset: options.value,
      units: options.units
    }).start(0);
    _this.setValueAtTime(options.value, 0);
    return _this;
  }
  /**
   * Callback which is invoked every tick.
   */
  _createClass(SyncedSignal, [{
    key: "_onTick",
    value: function _onTick(time) {
      var val = _get(_getPrototypeOf(SyncedSignal.prototype), "getValueAtTime", this).call(this, this.context.transport.seconds);
      // approximate ramp curves with linear ramps
      if (this._lastVal !== val) {
        this._lastVal = val;
        this._constantSource.offset.setValueAtTime(val, time);
      }
    }
    /**
     * Anchor the value at the start and stop of the Transport
     */
  }, {
    key: "_anchorValue",
    value: function _anchorValue(time) {
      var val = _get(_getPrototypeOf(SyncedSignal.prototype), "getValueAtTime", this).call(this, this.context.transport.seconds);
      this._lastVal = val;
      this._constantSource.offset.cancelAndHoldAtTime(time);
      this._constantSource.offset.setValueAtTime(val, time);
    }
  }, {
    key: "getValueAtTime",
    value: function getValueAtTime(time) {
      var computedTime = new TransportTimeClass(this.context, time).toSeconds();
      return _get(_getPrototypeOf(SyncedSignal.prototype), "getValueAtTime", this).call(this, computedTime);
    }
  }, {
    key: "setValueAtTime",
    value: function setValueAtTime(value, time) {
      var computedTime = new TransportTimeClass(this.context, time).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "setValueAtTime", this).call(this, value, computedTime);
      return this;
    }
  }, {
    key: "linearRampToValueAtTime",
    value: function linearRampToValueAtTime(value, time) {
      var computedTime = new TransportTimeClass(this.context, time).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "linearRampToValueAtTime", this).call(this, value, computedTime);
      return this;
    }
  }, {
    key: "exponentialRampToValueAtTime",
    value: function exponentialRampToValueAtTime(value, time) {
      var computedTime = new TransportTimeClass(this.context, time).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "exponentialRampToValueAtTime", this).call(this, value, computedTime);
      return this;
    }
  }, {
    key: "setTargetAtTime",
    value: function setTargetAtTime(value, startTime, timeConstant) {
      var computedTime = new TransportTimeClass(this.context, startTime).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "setTargetAtTime", this).call(this, value, computedTime, timeConstant);
      return this;
    }
  }, {
    key: "cancelScheduledValues",
    value: function cancelScheduledValues(startTime) {
      var computedTime = new TransportTimeClass(this.context, startTime).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "cancelScheduledValues", this).call(this, computedTime);
      return this;
    }
  }, {
    key: "setValueCurveAtTime",
    value: function setValueCurveAtTime(values, startTime, duration, scaling) {
      var computedTime = new TransportTimeClass(this.context, startTime).toSeconds();
      duration = this.toSeconds(duration);
      _get(_getPrototypeOf(SyncedSignal.prototype), "setValueCurveAtTime", this).call(this, values, computedTime, duration, scaling);
      return this;
    }
  }, {
    key: "cancelAndHoldAtTime",
    value: function cancelAndHoldAtTime(time) {
      var computedTime = new TransportTimeClass(this.context, time).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "cancelAndHoldAtTime", this).call(this, computedTime);
      return this;
    }
  }, {
    key: "setRampPoint",
    value: function setRampPoint(time) {
      var computedTime = new TransportTimeClass(this.context, time).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "setRampPoint", this).call(this, computedTime);
      return this;
    }
  }, {
    key: "exponentialRampTo",
    value: function exponentialRampTo(value, rampTime, startTime) {
      var computedTime = new TransportTimeClass(this.context, startTime).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "exponentialRampTo", this).call(this, value, rampTime, computedTime);
      return this;
    }
  }, {
    key: "linearRampTo",
    value: function linearRampTo(value, rampTime, startTime) {
      var computedTime = new TransportTimeClass(this.context, startTime).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "linearRampTo", this).call(this, value, rampTime, computedTime);
      return this;
    }
  }, {
    key: "targetRampTo",
    value: function targetRampTo(value, rampTime, startTime) {
      var computedTime = new TransportTimeClass(this.context, startTime).toSeconds();
      _get(_getPrototypeOf(SyncedSignal.prototype), "targetRampTo", this).call(this, value, rampTime, computedTime);
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(SyncedSignal.prototype), "dispose", this).call(this);
      this.context.transport.clear(this._synced);
      this.context.transport.off("start", this._syncedCallback);
      this.context.transport.off("pause", this._syncedCallback);
      this.context.transport.off("stop", this._syncedCallback);
      this._constantSource.dispose();
      return this;
    }
  }]);
  return SyncedSignal;
}(Signal);